import { HttpMethods } from '@codametrix/ui-common';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../core/net';

interface ListConfigurationsPayload {
  tenantId: string;
}

interface UpdateConfigurationValuePayload {
  configurationId: number;
  tenantId: string;
  configValue: CMxAPI.ConfigurationValue;
}

export const updateConfigurationValue = createAsyncThunk(
  'UPDATE_CONFIGURATION_VALUE',
  async (payload: UpdateConfigurationValuePayload) => {
    const { configurationId, tenantId, configValue } = payload;

    return await api(
      {
        endpoint: `/configuration/detail/updateValue/${configurationId}/${tenantId}/v2`,
        init: {
          method: HttpMethods.PUT,
          body: JSON.stringify(configValue)
        }
      },
      true,
      true
    );
  }
);

export const listConfigurations = createAsyncThunk(
  'LIST_CONFIGURATIONS',
  async (payload: ListConfigurationsPayload) => {
    const { tenantId } = payload;
    return await api({
      endpoint: `/configuration/listAllConfigurationByTenantId/${tenantId}/v2?includeEmptyConfigurations=true`,
      init: {
        method: HttpMethods.GET
      }
    });
  }
);

interface FetchConfigDetailPayload {
  configurationId: string | number;
  tenantId: string;
}

export const fetchConfigDetail = createAsyncThunk(
  'FETCH_CONFIG_DETAIL',
  async (payload: FetchConfigDetailPayload) => {
    const { configurationId, tenantId } = payload;
    return await api({
      endpoint: `/configuration/detail/${configurationId}/${tenantId}/v2?includeEmptyConfigurations=true`,
      init: {
        method: HttpMethods.GET
      }
    });
  }
);

export const toggleConfigDrawer = createAction<boolean>('TOGGLE_CONFIG_DRAWER');
export const toggleConfigDrawerContent = createAction<boolean>(
  'TOGGLE_CONFIG_DRAWER_CONTENT'
);

interface FetchConfigurationAuditPayload {
  tenantId: string;
  pageNumber?: number;
  pageSize?: number;
  serviceLine?: string;
  searchKey?: string;
}

export const fetchConfigurationAudit = createAsyncThunk(
  'FETCH_CONFIGURATION_AUDIT',
  async ({
    tenantId,
    pageNumber,
    pageSize,
    serviceLine,
    searchKey
  }: FetchConfigurationAuditPayload): Promise<
    CMxAPI.PageableList<CMxAPI.ConfigurationAuditEntry>
  > => {
    const params = new URLSearchParams({
      tenantId,
      pageNumber: pageNumber?.toString() || '1',
      pageSize: pageSize?.toString() || '20'
    });

    if (serviceLine) {
      params.append('serviceLine', serviceLine);
    }

    if (searchKey) {
      params.append('searchKey', searchKey);
    }

    return await api({
      endpoint: `/configuration/audit/configurationsValues?${params.toString()}`,
      init: {
        method: HttpMethods.GET
      }
    });
  }
);
